import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/button';

const PRODUCT_IMAGES = {
  family45: '/images/family-mini.jpg',
  family75: '/images/family-mini.jpg',
  newborn15: '/images/newborn-mini.jpg',
  newborn25: '/images/newborn-mini.jpg',
  maternity: '/images/pregnancy-mini.jpg',
  maternityFamily: '/images/pregnancy-mini.jpg',
};

export function VoucherCard({ product, onBuy }) {
  const { t } = useLanguage();
  const tProduct = t.vouchers.products[product.id] || { title: '', subtitle: '' };
  const image = PRODUCT_IMAGES[product.id];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
      whileHover={{ y: -4 }}
      className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 flex flex-col"
      data-testid={`voucher-card-${product.id}`}
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={tProduct.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
      </div>

      <div className="p-7 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3 className="font-heading text-xl text-warm-900 leading-tight">
            {tProduct.title}
          </h3>
          <Gift className="w-5 h-5 text-accent shrink-0 mt-1" />
        </div>
        <p className="text-warm-600 text-sm mb-6">{tProduct.subtitle}</p>

        <div className="mt-auto flex items-end justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-[2px] text-warm-500 mb-1">
              {t.vouchers.perfectGift}
            </div>
            <div className="font-heading text-3xl font-semibold text-warm-900">
              €{product.price_eur}
            </div>
          </div>
          <Button
            onClick={() => onBuy(product)}
            className="bg-accent hover:bg-accent-dark text-white font-medium px-5 py-2 rounded-full text-sm"
            data-testid={`buy-voucher-${product.id}`}
          >
            {t.vouchers.buy}
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
